import { FormConnectToObject } from 'app/views/forms/common/FormConnectToObject'
import { PdfPropsForm } from 'app/views/forms/common/PdfPropsForm'
import { useDispatch } from 'react-redux'
import { formComponentTypes } from '../../formComponentTypes'
import { FormBudgetUpdate } from './FormBudgetUpdate'

const FormEditorBudgetUpdate = ({
  id,
  showPdfProps,
  showPrintProps,
  editMode,
  depth,
  typeProps,
  injectable,
  injectableId,
  isInsideGroup,
  ...props
}) => {
  const dispatch = useDispatch()
  const _typeProps = typeProps || {}

  if (!editMode) {
    return (
      <FormBudgetUpdate editMode id={id} typeProps={_typeProps} {...props} />
    )
  }

  return (
    <div>
      {showPdfProps && (
        <PdfPropsForm
          typeProps={typeProps}
          dispatch={dispatch}
          injectable={injectable}
          depth={depth}
          isInsideGroup={isInsideGroup}
        />
      )}
      <FormConnectToObject
        injectable={injectable}
        injectableId={injectableId}
        typeProps={_typeProps}
        depth={depth}
        noField
        objectsConnections={
          formComponentTypes.budgetUpdate.connectsToMultipleObjects
        }
      />
    </div>
  )
}

export default FormEditorBudgetUpdate
